import React, { FC } from 'react';

import { formatter } from 'helpers';
import { useLang } from 'hooks';
import { InputProps } from 'types/components';

import Input from '.';

const formatValue = (value: string) => formatter.formatCardCode(value);

const CardCodeInput: FC<InputProps> = ({
  type = 'password',
  value,
  placeholder,
  onChange,
  ...props
}) => {
  const lang = useLang();

  const handleChange: InputProps['onChange'] = (event) => {
    event.target.value = formatValue(event.target.value);

    onChange?.(event);
  };

  return (
    <Input
      type={type}
      value={value && formatValue(value as string)}
      placeholder={placeholder ?? lang.get('common.form.cardCode.placeholder')}
      onChange={handleChange}
      {...props}
    />
  );
};

export default CardCodeInput;
